import { Input } from "../../../../../../shared/components/input/Input";

const CustomDatePicker = ({
  value,
  onChange,
  placeholder = "Select date",
  disabled,
  min,
  max,
}) => {
  return (
    <Input
      type="date"
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      disabled={disabled}
      className="w-full"
      min={min}
      max={max}
    />
  );
};

export default CustomDatePicker;
